import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Header = ({ backUrl }) => (
  <div className="px-7 pt-6 pb-2">
    <div className="flex items-start justify-between gap-4">
      <div>
        <h1 className="text-[22px] font-bold tracking-tight text-slate-900">
          {I18n.t("contracts_dashboard.title")}
        </h1>
        <p className="text-[12.5px] text-slate-500 mt-0.5">
          {I18n.t("contracts_dashboard.subtitle")}
        </p>
      </div>
      {backUrl && (
        <a href={backUrl}
           className="shrink-0 inline-flex items-center gap-2 text-[12.5px] font-semibold text-slate-600 hover:text-slate-900 border border-slate-200 bg-white rounded-lg px-3 py-2">
          <FontAwesomeIcon icon="arrow-left" className="w-3 h-3" />
          {I18n.t("contracts_dashboard.back")}
        </a>
      )}
    </div>

  </div>
)

export default Header
